var ENexiCharge;
(function (ENexiCharge) {
    // Esito di un singolo addebito (record piatto, niente più aggregati di batch)
    let Status;
    (function (Status) {
        Status["Ok"] = "ok";
        Status["Error"] = "error";
    })(Status = ENexiCharge.Status || (ENexiCharge.Status = {}));
    // Motivi di scarto riga per riga nell'import CSV (errori non bloccanti)
    let CsvReason;
    (function (CsvReason) {
        CsvReason["NotFound"] = "not_found";
        CsvReason["NoToken"] = "no_token";
        CsvReason["AlreadyCharged"] = "already_charged";
        CsvReason["Duplicate"] = "duplicate";
        CsvReason["NoAmount"] = "no_amount";
    })(CsvReason = ENexiCharge.CsvReason || (ENexiCharge.CsvReason = {}));
})(ENexiCharge || (ENexiCharge = {}));
export default ENexiCharge;
